export enum Sections {
  SIGNUPS = 'signups',
  ONBOARDING = 'onboarding',
  ONBOARDING_DASHBOARD = 'onboarding-dashboard',
  ONBOARDING_CONFIGURATION = 'onboarding-configuration',
  ONBOARDING_COMPANY = 'onboarding-company',
  ONBOARDING_DRIVERS = 'onboarding-drivers',
  ONBOARDING_VEHICLES = 'onboarding-vehicles',
  ONBOARDING_RATES = 'onboarding-rates',
  ONBOARDING_THRESHOLD = 'onboarding-threshold',
  DASHBOARD = 'dashboard',
  TRIPS = 'trips',
  LEVEL_OF_SERVICE = 'level-of-service',
  SPACE_TYPE = 'space-type',
  APPOINTMENT_TYPE = 'appointment-type',
  ADDONS = 'addons',
  SERVICE_AREA = 'service-area',
  CHANGE_REASON = 'change-reasons',
  PLACE_TYPE = 'place-type',
  QUICKBOOKS_CONFIG = 'quickbooks-config',
  MEMBER = 'member',
  FUNDING_SOURCE = 'funding-source',
  USER = 'user',
  STATISTICS = 'statistics',
  BILLING = 'billing',
  ROLES = 'roles',
  QUICKBOOKS = 'quickbooks'
}
